// TODO: swap to Typescript,
// but need to update all files that reference this file to TS first
// alternatively I could duplicate this to TS and slowly migrate
import { getContent } from '@/services/cms/util.js'
import sanitizeHtml from 'sanitize-html'

export function MMDDYYYY(date_string) {
	if (date_string == null) return 'invalid date'
	const dateify = new Date(date_string)
	const date = new Date(dateify.toISOString().slice(0, -1))

	let year = date.getFullYear()

	let month = (1 + date.getMonth()).toString()
	month = month.length > 1 ? month : '0' + month

	let day = date.getDate().toString()
	day = day.length > 1 ? day : '0' + day

	return month + '/' + day + '/' + year
}

export function prettyDate(date_string) {
	if (date_string == null) return 'invalid date'
	const dateify = new Date(date_string)
	const date = new Date(dateify.toISOString().slice(0, -1))

	let year = date.getFullYear()

	let month = (1 + date.getMonth()).toString()
	month = date.toLocaleString('default', { month: 'short' })

	let day = date.getDate().toString()
	day = day.length > 1 ? day : '0' + day

	return `${month} ${day}, ${year}`
}

export function YYYYMMDD(date_string) {
	if (date_string == null) return 'invalid date'
	const dateify = new Date(date_string)
	const date = new Date(dateify.toISOString().slice(0, -1))

	let year = date.getFullYear()

	let month = (1 + date.getMonth()).toString()
	month = month.length > 1 ? month : '0' + month

	let day = date.getDate().toString()
	day = day.length > 1 ? day : '0' + day

	return year + '-' + month + '-' + day
}

export function sortArrayByDate(array, dateKey, ascending = true) {
	return array.sort((a, b) => {
		const dateA = new Date(a[dateKey])
		const dateB = new Date(b[dateKey])
		if (ascending) {
			return dateA - dateB
		} else {
			return dateB - dateA
		}
	})
}

export function phoneNumberFormat(phoneNumberString, format = null) {
	const x = phoneNumberString.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
	if (format === 'hyphenate') {
		phoneNumberString = !x[2] ? x[1] : +x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '')
	} else {
		phoneNumberString = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
	}
	return phoneNumberString
}

export function toPascalCase(inputString) {
	if (!inputString) return inputString
	const words = inputString.trim().toLowerCase().split(' ')

	const pascalizedWords = words.map((word) => {
		return word.charAt(0).toUpperCase() + word.slice(1)
	})

	return pascalizedWords.join(' ')
}

export function concatFormatValidationErrors(errors) {
	let errorsString
	if (errors.length > 1) {
		errorsString = errors
			.map((e) => {
				return getContent(e.code)
			})
			.join(' ')
			.trim()
	} else {
		errorsString = getContent(errors[0].code)
	}
	return errorsString
}

function htmlEscape(str) {
	return String(str)
		.replace(/&/g, '&amp;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
}

export const session = {
	get(name) {
		return JSON.parse(sessionStorage.getItem(name || '{}'))
	},
	set(name, payload) {
		sessionStorage.setItem(name, JSON.stringify(payload))
	}
}

export const sanitize = (html) => {
	return sanitizeHtml(html, {
		allowedAttributes: {
			a: ['href', 'class', 'target'],
			p: ['class'],
			div: ['class'],
			span: ['class']
		}
	})
}

export const passwordRules = {
	currentPasswordValid(password) {
		return password.length >= 8
	},
	lengthRule(password) {
		return password.length >= 8
	},
	lowercaseRule(password) {
		return password.match('(?=.*[a-z])')
	},
	uppercaseRule(password) {
		return password.match('(?=.*[A-Z])')
	},
	numberRule(password) {
		return password.match('(?=.*[0-9])')
	},
	specialCharRule(password) {
		return (
			password.match(
				'(?=.*[-#!&@$%^*()_+=~`;:\'",.?</|\\]>[}{óÓôÔòÒñÑöÖ¡¿ÇçŒœßØøÅåÆæÞþÐð«»¢£¥€¤\\\\])'
			) &&
			!password.match(
				/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g
			)
		)
	}
}

export function disableByRange(start, end) {
	const startDate = new Date(start)
	const endDate = new Date(end)
	const today = new Date()

	return today >= startDate && today <= endDate ? true : false
}

export function mapPaStatus(status, outcome, full) {
	let output = false

	const mappingArray = [
		{ status: 'Approved', labelColor: 'green' },
		{ status: 'Authorization referred to outside Vendor', labelColor: 'red' },
		{ status: 'Authorization sent to wrong Payor', labelColor: 'purple' },
		{ status: 'Denied', labelColor: 'red' },
		{ status: 'Denied after Doctor to Doctor Review', labelColor: 'red' },
		{ status: 'Denied: Benefit Limit Exceeded', labelColor: 'red' },
		{ status: 'Denied: Insufficient Information', labelColor: 'red' },
		{ status: 'Denied: No Out of Network Benefit', labelColor: 'red' },
		{ status: 'Denied: Not a Covered Benefit', labelColor: 'red' },
		{ status: 'Denied: Please Refer to Denial Letter for Detailed Explanation', labelColor: 'red' },
		{ status: 'Denied: Pre-surgical requirements unmet', labelColor: 'red' },
		{ status: 'Extension Granted per Member Representative Request', labelColor: 'green' },
		{ status: 'Extension Granted per Member Request', labelColor: 'green' },
		{ status: 'Extension Granted per Provider Request', labelColor: 'green' },
		{ status: 'New Request', labelColor: 'grey' },
		{ status: 'No PA Required', labelColor: 'green' },
		{ status: 'Not Eligible for Review after Services Rendered', labelColor: 'purple' },
		{ status: 'Partial Denial: Please contact your provider', labelColor: 'red' },
		{ status: 'Under Review', labelColor: 'red' },
		{ status: 'Withdrawn per Member Representative Request', labelColor: 'grey' },
		{ status: 'Withdrawn per Member Request', labelColor: 'grey' },
		{ status: 'Withdrawn per Provider Request', labelColor: 'grey' }
	]

	function checkForNull(a, b) {
		return (a != null ? a.toLowerCase() : a) === (b != null ? b.toLowerCase() : b)
	}

	mappingArray.forEach((x) => {
		if (checkForNull(status, x.status)) {
			output = {
				status: x.status,
				labelColor: x.labelColor
			}
		}
	})

	if (output) {
		return {
			status: output.status,
			labelColor: output.labelColor
		}
	} else {
		return false
	}
}

/** Deprecated: Moving to utils/tracking.ts -> createLrEvent */
export function trackEvent(eventName, options) {
	try {
		window.LogRocket?.track(eventName, options)
	} catch (err) {
		console.error('LogRocket failed: ', err)
	}
}
